import { render } from "./VendorsReadSingleView.vue?vue&type=template&id=18b5da64"
import script from "./VendorsReadSingleView.vue?vue&type=script&lang=js"
export * from "./VendorsReadSingleView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__